import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { ROUTES, BASE_URL } from '../seo/routeMetadata';

const HowItWorksPage = () => {
  const meta = ROUTES['/how-it-works'];

  return (
    <div className="min-h-screen bg-[#050810]">
      <SEO
        title={meta.title}
        description={meta.description}
        keywords={meta.keywords}
        url={`${BASE_URL}${meta.path}`}
        jsonLd={meta.jsonLd}
      />
      <Header />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
        <header className="mb-10 pb-8 border-b border-[#1e2a45]">
          <nav aria-label="Breadcrumb" className="mb-6 text-xs text-gray-500">
            <Link to="/" className="hover:text-white">Home</Link>
            <span className="mx-2 text-gray-600">›</span>
            <span className="text-gray-400">How It Works</span>
          </nav>

          <h1 className="text-4xl sm:text-5xl font-bold text-white leading-tight mb-4" data-testid="page-h1">
            {meta.h1}
          </h1>
          <p className="text-lg text-gray-200 leading-relaxed max-w-3xl">{meta.aeoAnswer}</p>
        </header>

        <div className="space-y-10">
          {meta.sections.map((s) => (
            <section key={s.h2}>
              <h2 className="text-2xl font-semibold text-white mb-3">{s.h2}</h2>
              <p className="text-gray-300 leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>

        {meta.faq && (
          <section className="mt-16 border-t border-[#1e2a45] pt-10">
            <h2 className="text-2xl font-semibold text-white mb-6">Frequently Asked Questions</h2>
            <div className="space-y-6">
              {meta.faq.map((f) => (
                <div key={f.q}>
                  <h3 className="text-lg font-medium text-white mb-2">{f.q}</h3>
                  <p className="text-gray-400">{f.a}</p>
                </div>
              ))}
            </div>
          </section>
        )}

        <div className="mt-16 rounded-2xl border border-[#F97316]/30 bg-gradient-to-r from-[#F97316]/10 to-[#3B82F6]/10 p-8">
          <h3 className="text-2xl font-bold text-white mb-3">Ready to start forecasting?</h3>
          <p className="text-gray-300 mb-6">Create a free account and receive a virtual TK¢ starter balance instantly. No credit card required.</p>
          <div className="flex flex-wrap gap-3">
            <Link to="/" className="bg-[#F97316] hover:bg-[#EA580C] text-white px-6 py-3 rounded-full font-semibold" data-testid="cta-explore-markets">
              Explore Markets
            </Link>
            <Link to="/ideas" className="bg-[#1e2a45] hover:bg-[#2d3a56] text-white px-6 py-3 rounded-full font-semibold" data-testid="cta-create-idea">
              Propose a Market
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default HowItWorksPage;
